import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="lightgreencontentbg keyquestionpad uiheading">

                                                <div className="border_subtitle">The right-hand rule</div>
                                                <img
                                                    src={require('@images/formlate_img.png')}
                                                    alt="" align="right" style={{width: '29%', paddingLeft: '5px'}}/>
                                                <p>The right-hand rule, sometimes referred to
                                                    as the wall-follower, is thought to be the
                                                    best-known rule for traversing mazes; this
                                                    rule works on the fact that all the walls of
                                                    the maze are connected together or to the
                                                    maze’s outer boundary. By keeping one
                                                    hand in contact with one wall of the maze
                                                    the player is guaranteed not to get lost and will reach
                                                    a different exit if there is one; otherwise,
                                                    they will return to the entrance. This strategy works
                                                    best when implemented immediately
                                                    upon entering the maze.</p>


                                            </div>


                                            <div className="border_subtitle">This tool can help</div>
                                            <p>
                                                There is not always such a straightforward rule or plan of
                                                action to follow, but by planning ahead
                                                you are increasing your chances of reaching your destination
                                                quickly and effectively. This tool is all
                                                about <span
                                                className="brown brownbold"> how to formulate action plans</span> and
                                                provides you with details of how and when plans should
                                                be evaluated or adjusted. This will help you to break down
                                                overall plans into more manageable
                                                chunks in order to more easily achieve your goals.
                                            </p>


                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>SEVEN-STAGE ACTION PLAN MODEL
                                            </div>
                                            <p>Action planning can be applied to any task or project, big or
                                                small, and is critical to the timely
                                                achievement of your goals. Effective action planning will help
                                                you to understand the breakdown
                                                of your task, what you need to do to achieve each stage and,
                                                where appropriate, how one task
                                                may be dependent on another.
                                            </p>
                                            <p>It is fair to say that the action planning process can be seen as
                                                a cycle. The way in which you plan
                                                your actions will have an impact on the outcomes. In turn, the
                                                outcomes will impact the way you
                                                plan your next action. This model depicts the stages of an
                                                action plan and outlines some of the
                                                points that need to be considered at each stage of your
                                                plan.</p>
                                            <p>This type of approach also works if there are several goals
                                                combined into an ‘I need to clear my
                                                desk’ requirement.</p>

                                            <p><span className="subtiltereg">The seven stages</span></p>
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/wrks1.png')}
                                                    alt=""/>

                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}